import type { ReactNode } from 'react';

import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';

type SitePageLayoutProps = {
  title: string;
  effectiveDate: string;
  children: ReactNode;
};

export default function SitePageLayout({
  title,
  effectiveDate,
  children,
}: SitePageLayoutProps) {
  return (
    <div className="app legal-app">
      <SiteHeader />
      <main id="main-content" tabIndex={-1} className="legal-main">
        <div className="content-well legal-content">
          <h1>{title}</h1>
          <p className="legal-effective">Effective date: {effectiveDate}</p>
          {children}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
